<template>
  <AccountFrame>
    <ResetPasswordForm v-if="step === 0" v-model:step="step" />
    <SuccessFrame
      v-else
      title="แก้ไขรหัสผ่านสำเร็จ"
      btn-text="เข้าสู่ระบบ"
      :on-click="handleClick"
    >
      <div class="flex grow place-content-center">
        <CheckCircleIcon class="w-36 text-green" />
      </div>
    </SuccessFrame>
  </AccountFrame>
</template>

<script setup lang="ts">
import AccountFrame from "@/components/account/AccountFrame.vue";
import { ROUTE_NAMES } from "@/router/constants";
import { CheckCircleIcon } from "@heroicons/vue/24/outline";
import { defineAsyncComponent, ref, watch } from "vue";
import { useMeta } from "vue-meta";
import { useRouter } from "vue-router";

useMeta({ title: "แก้ไขรหัสผ่าน" });

const router = useRouter();
const step = ref<number>(0);
const timeout = ref();

const ResetPasswordForm = defineAsyncComponent(
  () => import("@/components/forms/ResetPasswordForm.vue"),
);
const SuccessFrame = defineAsyncComponent(
  () => import("@/components/account/SuccessFrame.vue"),
);

function changePage() {
  router.push({ name: ROUTE_NAMES.LOGIN });
}

function setTimeOutClose() {
  timeout.value = setTimeout(changePage, 5000);
}

function handleClick() {
  clearTimeout(timeout.value);
  changePage();
}

watch(
  () => step.value,
  (newStep) => {
    if (newStep > 0) setTimeOutClose();
  },
);
</script>
